import React, { FC, useLayoutEffect, useRef, useState } from 'react';
import { useRouter } from 'next/navigation';
import { Category } from 'shared/types/product/Category';
import Button from 'components/commercetools-ui/atoms/button';
import Link from 'components/commercetools-ui/atoms/link';
import Typography from 'components/commercetools-ui/atoms/typography';
import MarketButtonMobile from 'components/commercetools-ui/organisms/market-button/market-button-mobile';
import { useFormat } from 'helpers/hooks/useFormat';
import { useAccount } from 'frontastic';
import MobileMenuNavButton from '../atoms/menu-nav-button';
import { ChevronDownIcon } from '@heroicons/react/24/outline';
import { InformationCircleIcon } from '@heroicons/react/24/solid';

export interface Props {
  showMenu: boolean;
  insertCategory: (category: Category) => void;
  hideHeaderMenu: () => void;
}

const MobileMenuFooter: FC<Props> = ({ showMenu, hideHeaderMenu, insertCategory }) => {
  const router = useRouter();
  const { formatMessage } = useFormat({ name: 'common' });
  const { formatMessage: formatAccountMessage } = useFormat({ name: 'account' });
  const { formatMessage: formatCommonMessage } = useFormat({ name: 'common' });
  const marketButtonRef = useRef<HTMLDivElement>(null);
  const { account, logout } = useAccount();
  const [languageMenuTop, setLanguageMenuTop] = useState(false);

  const tabs = [
    { name: formatAccountMessage({ id: 'my.account', defaultMessage: 'My Account' }), href: '/account#' },
    { name: formatAccountMessage({ id: 'orders', defaultMessage: 'Orders' }), href: '/account#orders' },
    {
      name: formatAccountMessage({ id: 'payment.methods', defaultMessage: 'Payment methods' }),
      href: '/account#payment',
    },
    { name: formatAccountMessage({ id: 'addresses', defaultMessage: 'Addresses' }), href: '/account#addresses' },
    {
      name: formatAccountMessage({ id: 'customer.support', defaultMessage: 'Customer support' }),
      href: '/account#support',
    },
  ];

  const accountButton: Category = {
    categoryId: 'myAccount',
    name: formatAccountMessage({ id: 'my.account', defaultMessage: 'My Account' }),
    depth: 1,
    subCategories: tabs.map((tab) => {
      return { categoryId: tab.href, name: tab.name, slug: tab.href, subCategories: [], depth: 1 };
    }),
  };

  const handleLogout = () => {
    logout().then(() => router.push('/login'));
    hideHeaderMenu();
  };

  useLayoutEffect(() => {
    if (marketButtonRef.current) {
      if (window.innerHeight - marketButtonRef.current.getBoundingClientRect().bottom < 100) setLanguageMenuTop(true);
      else setLanguageMenuTop(false);
    }
  }, [showMenu]);

  return (
    <>
      <div className="flex gap-18 m-0 m-auto w-full bg-[#F3EDE9]  pl-24 pr-22 md:hidden py-48">
        {/* <Link link="/help" onClick={hideHeaderMenu} className="flex justify-center">
          <Typography className="text-14 font-medium text-black">{formatCommonMessage({
                id: 'help.center',
                defaultMessage: 'Help Center',
              })}</Typography>
          <ChevronDownIcon className="ml-5 mt-4 w-16 font-medium text-secondary-black" />
        </Link> */}
        {/* <Link link="https://plumber.caroma.com.au/" onClick={hideHeaderMenu} className="flex justify-center pt-24" rel="noopener noreferrer" target="_blank">
          <Typography className="text-14 font-medium text-black">
            {formatCommonMessage({
                  id: 'plumbers',
                  defaultMessage: 'Plumbers',
            })}
          </Typography>
          <InformationCircleIcon className="ml-3 mt-1 w-16 text-[#666] hover:cursor-pointer hover:text-[#333]" />
        </Link>
        <Link link="https://specify.caroma.com.au/" onClick={hideHeaderMenu} className="flex justify-center pt-24" rel="noopener noreferrer" target="_blank">
          <Typography className="text-14 font-medium text-black">{formatCommonMessage({
                id: 'help.specifiers',
                defaultMessage: 'specifiers',
          })}
          </Typography>
          <InformationCircleIcon className="ml-3 mt-1 w-16 text-[#666] hover:cursor-pointer hover:text-[#333]" />
        </Link> */}
      </div>
      {/* {account ? (
        <div className="ml-24 mr-22 block pt-16 md:hidden">
          <MobileMenuNavButton
            link={accountButton}
            onClick={() => insertCategory(accountButton)}
            hideHeaderMenu={hideHeaderMenu}
          />
        </div>
      ) : (
        
      )}

      <div className="mx-24 flex py-16">
        {account ? (
          <Button variant="ghost" size="fit" onClick={handleLogout}>
            <Typography className="font-normal text-primary-black">
              {formatAccountMessage({ id: 'sign.out', defaultMessage: 'Sign out' })}
            </Typography>
          </Button>
        ) : (
          <Link link="/login" onClick={hideHeaderMenu} className="px-0">
            <Typography className="text-14 font-normal text-primary-black">
              {formatAccountMessage({ id: 'sign.in', defaultMessage: 'Sign in' })}
            </Typography>
          </Link>
        )}
      </div>
      <div className="p-16" ref={marketButtonRef}>
        <MarketButtonMobile menuTop={languageMenuTop} />
      </div> */}
    </>
  );
};

export default MobileMenuFooter;